import React, { useState } from 'react';
import './FAQItem.css';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`item ${isOpen ? 'open' : ''}`} onClick={toggleOpen}>
      <div className="title font-bold flex justify-between items-center">
        <span className="text-lg md:text-xl">{question}</span>
        <div className={`icon-wrapper ${isOpen ? 'rotate' : ''}`}>
          {isOpen ? <FaChevronUp className="icon" /> : <FaChevronDown className="icon" />}
        </div>
      </div>
      <p className={`text ${isOpen ? 'show' : ''}`}>{answer}</p>
    </div>
  );
};

const FAQ = () => {
  const faqs = [
    { 
        question: 'What happens after I book a call?', 
        answer: 'Once you book a call, we’ll have a **free 15–20 minute consultation** where I take the time to understand your goals, challenges, and lifestyle. Based on that, I’ll suggest a **personalized roadmap** that sets you up for long-term success. No generic plans—just a strategy that works for **you.**' 
    },
    { 
        question: 'Do I need a gym?', 
        answer: 'Absolutely **not!** Whether you have access to a gym or prefer working out at home, I create **customized plans** tailored to your environment. No fancy equipment needed—just a **willingness to commit** and follow the process!' 
    },
    { 
        question: 'Will I get a diet chart?', 
        answer: 'No **boring, restrictive meal charts** here! Instead, you’ll receive **flexible food guidelines** that align with your lifestyle, preferences, and goals. You’ll learn **how to eat, not just what to eat**, making healthy eating sustainable for life.' 
    },
    { 
        question: 'Can I still drink alcohol and eat out?', 
        answer: 'Yes! The goal is to build a system where you can enjoy life without feeling guilty. Whether it’s a weekend outing, a celebration, or just an occasional indulgence, I’ll teach you how to **balance** your diet so you never feel the need to "restart" on Monday again.' 
    }
];


  return (
    <div className="container p-4 md:p-8 mx-auto text-zinc-700 flex-col divide-y-2 divide-solid divide-white divide-opacity-5">
      <h1 className="text-3xl font-bold text-center mb-2">FAQ</h1>
      <p className="text-center text-lg text-gray-600 mb-6">Got Questions? I Got You</p>
      {faqs.map((faq, index) => (
        <FAQItem key={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
  );
};

export default FAQ;
